import { getAlgoliaResults } from '@algolia/autocomplete-js';

import { Autocomplete } from './Autocomplete';
import { searchClient } from './searchClient';
import { SearchRounded } from '@mui/icons-material';
import { SearchBoxActivity } from './SearchActivity';

const SearchBoxWithSuggestions = ({ fixToTop, querySelected, initialQuery }) => {
    const containerClassName = fixToTop ?
        'algoliaCustom appSearchBoxDock fixToTop' :
        'algoliaCustom appSearchBoxDock';

    function TopicItem({ hit, components }) {
        
        const onClick = () => {
            querySelected(hit.name);
        }

        return (
            <button style={{ textAlign: 'left' }} onClick={onClick}>
                <span style={{ verticalAlign: 'middle' }}>
                    <SearchRounded style={{ fontSize: '26px', margin: '0px 6px 0px 8px', verticalAlign: 'middle', color: 'var(--app-text-secondary)'}} />
                </span>
                <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>
                    <components.Highlight hit={hit} attribute="name" />
                </span>
            </button>
        );
    }
    
    const onSubmit = ({ state }) => {
        querySelected(state.query);
    }

    return (
        <div className={containerClassName}>
            <SearchBoxActivity>
                <Autocomplete
                    placeholder='Search'
                    openOnFocus={true}
                    onSubmit={onSubmit}
                    onReset={() => querySelected('')}
                    initialState={{
                        query: initialQuery
                    }}
                    getSources={({ query }) => [
                        {
                            sourceId: 'sourceId',
                            getItems() {
                                return getAlgoliaResults({
                                    searchClient,
                                    queries: [
                                        {
                                            indexName: 'topics',
                                            query,
                                        },
                                    ],
                                });
                            },
                            templates: {
                                item({ item, components }) {
                                    return <TopicItem hit={item} components={components} />;
                                },
                            },
                        },
                    ]}
                />
            </SearchBoxActivity>
        </div>
    );
}

export default SearchBoxWithSuggestions;
